import React from "react";
import { Shield, Mail, Users } from "lucide-react";

const PrivacyPage: React.FC = () => {
  return (
    <div className="flex justify-center items-start min-h-screen bg-orange-50 pt-[120px] pb-[80px] px-4">
      <div className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-8 sm:p-10 max-w-3xl w-full text-center border border-orange-100">
        {/* === TITLE === */}
        <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 mb-4 flex justify-center items-center gap-2">
          <Shield size={28} /> Personvernerklæring
        </h1>

        {/* === INTRO === */}
        <p className="text-gray-700 leading-relaxed mb-6">
          Denne personvernerklæringen forklarer hvordan{" "}
          <strong>FonteneLunsj</strong> samler inn, bruker og beskytter
          opplysninger om deg når du bruker appen.
        </p>

        <hr className="border-orange-200 my-6" />

        {/* === WHAT WE COLLECT === */}
        <div className="space-y-4 text-left sm:text-center">
          <p className="text-gray-700">
            🔍 <strong>Hvilke data vi lagrer</strong>
          </p>
          <p className="text-gray-700">
            Vi lagrer kun nødvendig informasjon for at appen skal fungere:
          </p>
          <ul className="text-gray-700 list-disc list-inside">
            <li>Brukernavn</li>
            <li>Email</li>
            <li>Rolle/tilgangsnivå</li>
            <li>Forslag til oppskrifter/menyer</li>
            <li>Enkle bruksdata</li>
          </ul>
        </div>

        <hr className="border-orange-200 my-6" />

        {/* === PURPOSE === */}
        <div className="text-gray-700 leading-relaxed">
          <p className="mb-3">
            🎯 <strong>Hvorfor vi samler inn data</strong>
          </p>
          <p>
            Opplysningene brukes kun for å gi deg tilgang til funksjonene i
            FonteneLunsj, lagre bidragene dine og sikre en trygg og stabil
            brukeropplevelse.
          </p>
        </div>

        <hr className="border-orange-200 my-6" />

        {/* === STORAGE & SECURITY === */}
        <div className="text-gray-700 leading-relaxed">
          <p className="mb-3">
            🔐 <strong>Lagring og sikkerhet</strong>
          </p>
          <p>
            Vi tar sikkerhet på alvor. Passord lagres aldri i klartekst, og all
            kommunikasjon er sikret. Tilgang til data er begrenset til
            autoriserte personer.
          </p>
        </div>

        <hr className="border-orange-200 my-6" />

        {/* === RIGHTS === */}
        <div className="text-gray-700 leading-relaxed">
          <p className="mb-3">
            🧾 <strong>Dine rettigheter</strong>
          </p>
          <p>
            Du har rett til innsyn i hvilke opplysninger vi har om deg, og kan
            be om retting eller sletting av data når som helst.
          </p>
        </div>

        <hr className="border-orange-200 my-6" />

        {/* === CHANGES === */}
        <div className="text-gray-700 leading-relaxed">
          <p className="mb-3">
            🔄 <strong>Endringer i erklæringen</strong>
          </p>
          <p>
            Vi kan oppdatere denne personvernerklæringen ved behov. Større
            endringer vil vises tydelig i appen.
          </p>
        </div>

        {/* === CONTACT === */}
        <div className="mt-10 border-t border-orange-200 pt-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-4 flex justify-center items-center gap-2">
            <Users size={20} /> Kontakt
          </h2>

          <p className="text-gray-700 mb-2">
            Har du spørsmål om personvern? Ta kontakt med oss:
          </p>

          <div className="flex justify-center items-center gap-6 mt-4">
            <a
              href="mailto:post@fontenehuset-oslosor.no"
              className="flex items-center gap-2 text-orange-600 hover:text-orange-700 transition"
            >
              <Mail size={18} /> E-post
            </a>
          </div>

          <p className="text-sm text-gray-500 italic mt-6">
            Sist oppdatert: {new Date().toLocaleDateString("nb-NO")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
